@if (component) {
@for (item of component.items; track item;) {
<div class="p-b-2 p-b-5-s cursor-pointer"
     [class]="component.menuTitleFont || ''"
     [innerHTML]="$index + 1 + '. ' + item.title"
     (click)="scrollToIndex($index)">
</div>
}
@for (item of component.items; track item;) {
<div class="p-t-10">
    <p [class]="[component.contentTitleFont || '']"
       class="p-b-1"
       [attr.id]="'item_' + $index">
        <span>{{ $index + 1}}.</span>
        {{item.title}}
    </p>
    <p [class]="component.contentFont || ''"
       *iCms="'content' of item">
    </p>
</div>
}
}